<template>
  <div :class="`dropdown-component ${className}`">
    <b-dropdown  no-caret>
      <template v-slot:button-content>
        <div class="dd-selected">
          <span class="dd-title">{{ selectedValue.label }}</span>
          <div class="open-indicator-arrows">
            <div class="arrow-up"></div>
            <div class="arrow-down"></div>
          </div>
        </div>
      </template>
      <b-dropdown-item href="#" v-for="(option, index) in options" :key="'option' + index" @click="selectedValue = option">
        <span class="dd-title">{{ option.label }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  data() {
    return {
      selectedValue: {}
    };
  },
  watch: {
    selectedValue: function(newVal, oldVal) {
      this.$emit("itemselected", newVal, "galleryrow" + newVal.id);
    },
    initialItem: function(newVal, oldVal) {
      this.selectedValue = newVal;
    }
  },
  methods: {},
  props: {
    className: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    initialItem: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (!this.initialItem.placeholder) {
      this.selectedValue = this.initialItem;
    }
  }
};
</script>

<style lang="scss">
$primary-color-transparent: rgba(0,0,0,0.5);
.dropdown-component {
  max-width: 335px;
  width: 335px;
  font-family: "Interstate-Regular";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  color: #ffffff;
  .dropdown {
    width: 100%;
    .dropdown-menu {
      width: 100%;
      background-color: $primary-color-transparent;
    }
    .dropdown-item {
      &:hover {
        background-color: $primary-color-transparent;
        .dd-title {
          color: $secondary-color;
        }
      }
    }
  }
  .dd-selected {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #ffffff;
    padding: 4px 0px;
    margin: 0;
  }
  .vs__selected {
  }

  .vs__selected-options {
    height: 54px;
  }

  .vs__dropdown-toggle {
    border-bottom: 1px solid #607193;
    background: rgba(16, 21, 31, 0.2);
  }
  input {
    cursor: pointer;
  }
  div {
    cursor: pointer;
  }
  .dd-title {
    font-family: "Interstate-Regular";
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 21px;
    margin-right: 4px;
  }
  .dd-date {
    font-family: "Interstate-Regular";
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    line-height: 21px;
  }
  .open-indicator-arrows {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    .arrow-up {
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #f0f0f0;
      margin-bottom: 2px;
    }

    .arrow-down {
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #f0f0f0;
      margin-top: 2px;
    }
  }
}
</style>